import { IBannerDependsOnPromocode } from "../banners.t";
import { useSelector } from "react-redux";
import { getActivePromocodes } from "../../Bonus/bonusesSelectors";
import { useMemo } from "react";
import _ from "lodash";
import { BANNER_DEPENDS_ON_PROMOCODE_STATES } from "../bannersConstants";
import useDepositPromocodesEnd from "../../Deposit/components/DepositPromocodes/hooks/useDepositPromocodesEnd";

function useBannerDependsOnPromocodeConfig(dependsOnConfigPromocode?: IBannerDependsOnPromocode) {
    const activePromocodes = useSelector(getActivePromocodes);

    const promocode = useMemo(() => {
        if (!dependsOnConfigPromocode || dependsOnConfigPromocode.state !== BANNER_DEPENDS_ON_PROMOCODE_STATES.ACTIVE) return null;
        return _.find(activePromocodes, {
            promocode: dependsOnConfigPromocode.value,
        });
    }, [activePromocodes, dependsOnConfigPromocode]);

    const { secondsLeft: promocodeSecondsLeft } = useDepositPromocodesEnd(promocode);

    return {
        promocodeSecondsLeft,
    }
}

export default useBannerDependsOnPromocodeConfig;
